import {IconButton, useMediaQuery} from "@material-ui/core";
import {Brightness7, NightsStay} from "@material-ui/icons";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {toggleDarkMode} from "../redux/actions/actions";

export default function ToggleDarkModeBtn({examHeader}){
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl= useMediaQuery('(min-width:1200px)');
    const darkReducer=useSelector(state=>state.darkMode);
    const dispatch=useDispatch();
    console.log('IS DARK =', darkReducer.data);
    if( !darkReducer.data) {
        return (
            <IconButton
                style={examHeader ? {padding : 0}  : {}}
                onClick={()=>{
                    if(window.matchMedia("(prefers-color-scheme: dark)")){
                        document.body.classList.toggle('lightMode');
                    }else{
                        document.body.classList.toggle('darkMode');
                    }
                    // localStorage.setItem('isDark' , JSON.parse(false) );
                    dispatch(toggleDarkMode());
                }}
            >
                <NightsStay
                    style={{color : 'black' , fontSize: !examHeader ? 30 : lg ? 20 : 12 }}
                />
            </IconButton>
        )
    }else {
        return(
            <IconButton
                style={examHeader ? {padding : 0}  : {}}
                onClick={()=>{
                    if(window.matchMedia("(prefers-color-scheme: dark)")){
                        document.body.classList.toggle('lightMode');
                    }else{
                        document.body.classList.toggle('darkMode');
                    }
                    // localStorage.setItem('isDark' , JSON.parse(true ));
                    dispatch(toggleDarkMode())
                }}
            >
                <Brightness7
                    style={{color: 'gold', fontSize: !examHeader ? 30 : lg ? 20 : 12}}
                />
            </IconButton>
        )

    }
}
